import { _body } from '@whitetail/buckshot/scripts/core/variables';
import $ from '@whitetail/buckshot/scripts/buckshot-dom';

class PageType {
    constructor() {
        this.page = $(_body).data('page');
    }

    getPageType() {
        return this.page;
    }
}

const pageType = new PageType();

export default pageType.getPageType();
